const segment = (value: string): string => encodeURIComponent(value);

export const PLANT_ENDPOINTS = {
  DETAILS: '/assets/plantDetails',
  PROFILE: (plantId: string) => `/v2/plants/${segment(plantId)}/profile`,
  NAME: '/visualization/entityName',
} as const;
